import React from 'react';

import ProgressIcon from 'images/icons/progress/progressIcon.svg';

import ProgressSlider from './progressSlider';

import {
  BannerContainer,
  BannerText,
  BannerTitle,
  BannerSubtitle,
  PotencialBloom,
  PotencialHeader,
  PotencialTitle,
  PotencialPercentage
} from '../style';

function WelcomeBanner({ userName, statusColors, configuredCount }) {
  const percentage = Math.round((configuredCount / 3) * 100);

  return (
    <BannerContainer>
      <BannerText>
        <BannerTitle>
          Olá <span>{userName}</span>, bem vindo de volta!
        </BannerTitle>
        <BannerSubtitle>
          Acompanhe diariamente por aqui sua Operação para melhorar o resultado
          do seu Restaurante
        </BannerSubtitle>
      </BannerText>

      <PotencialBloom>
        <PotencialHeader>
          <img
            src={ProgressIcon}
            alt="Potencial Bloom"
            width={22}
            height={16}
          />
          <PotencialTitle>Potencial Bloom:</PotencialTitle>
          <PotencialPercentage>{percentage}%</PotencialPercentage>
        </PotencialHeader>

        <ProgressSlider
          statusColors={statusColors}
          configuredCount={configuredCount}
        />
      </PotencialBloom>
    </BannerContainer>
  );
}


export default WelcomeBanner;
